import React, { useEffect } from 'react'

import { useGiveawayTracker, useGetGiveawayDetail } from '../hook'
import { useBoolean, useRequest, useMount } from 'ahooks'
import { getIsGiveawayPopUp } from '@/services/api'
import { useHistory } from 'react-router-dom'
import { CenterPopup } from 'antd-mobile'
import styles from './index.module.less'
import { GiveawayActivityStatus } from '@/services/api/giveaway/type'
let hasShow = false

const iconClose = (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 5L19 19" stroke="#415066" stroke-width="1.5" />
    <path d="M19 5L5 19" stroke="#415066" stroke-width="1.5" />
  </svg>
)

/** 优惠活动弹窗 */
export const GiveawayModal: React.FC = () => {
  const [visible, { setTrue, setFalse }] = useBoolean()

  const history = useHistory()

  const { trackGiveawayModalOpen, trackGiveawayClick } = useGiveawayTracker()

  const { modalPic, status, seq } = useGetGiveawayDetail()

  // 判断是否弹出
  const { data: isModalShow, run: checkOpenModal } = useRequest(getIsGiveawayPopUp)

  useEffect(() => {
    if (isModalShow && status === GiveawayActivityStatus.NotParticipate && !hasShow && modalPic) {
      const img = new Image()
      img.src = modalPic
      img.onload = () => {
        setTrue()
        trackGiveawayModalOpen()
        hasShow = true
      }
    }
  }, [isModalShow, modalPic, setTrue, status, trackGiveawayModalOpen])

  useMount(() => {
    checkOpenModal()
  })

  const onClose = () => {
    setFalse()
  }

  const onClick = () => {
    trackGiveawayClick()
    history.push(`/questionnaire/${seq}`)
    setFalse()
  }

  return (
    <CenterPopup visible={visible} onClose={onClose} bodyClassName={styles.body} className={styles.modal}>
      <img className={styles.img} src={modalPic} alt="giveaway" onClick={onClick} />
      <div className={styles.closeBtn} onClick={onClose}>
        {iconClose}
      </div>
    </CenterPopup>
  )
}
